/* eslint-disable react-hooks/exhaustive-deps */
import Sx from "icons/sx.svg"
import immer from "immer"
import { useEffect, useState } from "react"
import { Checkbox } from "react-vant"
import { cls } from "reactutils"
import { Item } from "./CategoriesDrawer"
import FixedTab from "./FixedTab"
import OrderDrawer from "./OrderDrawer"

type OrderBy = 1 | 2 | null

type FilterPaneFixedProps = {
  tabs: { label: string; val: string | number }[]
  change: (_v) => void
  validOrderChange: (_b) => void
  value?: { [key: string]: any }
  tabkey?: string
  searchKey?: string
  conditionList?: Item[]
  searchDates?: { title: string; range: string[] }[]
}

export default function FilterPaneFixed({
  tabs = [],
  conditionList,
  searchDates,
  change,
  validOrderChange,
  value = {},
  tabkey = "orderStatusList",
}: FilterPaneFixedProps) {
  const [visible, setVisible] = useState(false)
  const [active, setActive] = useState(false)
  const [currentTab, setCurrentTab] = useState(0)

  const changeTab = (v) => {
    if (v.isFixed) {
      // 如果是isFixed的 直接返回,逻辑自行处理
      change({ ...value, isFixed: true })
    } else {
      change({
        ...value,
        isFixed: false,
        [tabkey]: v.name === 0 ? [] : [tabs[v.name].val],
      })
    }
  }

  function getOrderBy(sortField) {
    const sortItem = value?.sorts?.find((item) => item.sortField === sortField)
    return sortItem?.orderBy || null
  }

  function setOrderBy(sortFields: Array<string>) {
    const newValue = immer(value, (draftValue) => {
      const filterItem: Array<any> =
        draftValue?.sorts?.filter((item) =>
          sortFields.includes(item.sortField),
        ) || []
      if (filterItem?.length) {
        let orderBy = filterItem[0].orderBy
        if (orderBy === 1) {
          orderBy = 2
        } else {
          orderBy = 1
        }
        filterItem.forEach((item) => {
          item.orderBy = orderBy
        })
      } else {
        if (!draftValue?.sorts) {
          draftValue.sorts = []
        }
        sortFields.forEach((sortField) => {
          filterItem.push({ sortField, orderBy: 1 })
        })
      }
      draftValue.sorts = filterItem
    })
    change({
      ...value,
      ...newValue,
    })
  }

  useEffect(() => {
    if (value?.[tabkey]?.length === 1) {
      setCurrentTab(tabs.findIndex((v) => v.val === value?.[tabkey][0]))
    } else if (value?.paymentStatus === 5) {
      setCurrentTab(8)
    } else {
      setCurrentTab(0)
    }
  }, [value?.[tabkey]])

  useEffect(() => {
    const condition = conditionList.map((v) => v.prop)
    setActive(condition?.some((v) => value[v]?.length > 0))
  }, [value])

  return (
    <>
      <div className={cls("custom-tabs")}>
        <FixedTab tabs={tabs} onClickTab={changeTab} active={currentTab} />
      </div>
      <div className="sub-filter">
        <Checkbox iconSize="14px" onChange={validOrderChange}>
          只看有效订单
        </Checkbox>
        <div className="right-case">
          <div
            onClick={() => {
              setOrderBy(["in_date"])
            }}
          >
            <span>时间</span>
            <SortIcon orderBy={getOrderBy("in_date")}></SortIcon>
          </div>

          <div className="filter-btn">
            <span
              onClick={() => setVisible(true)}
              className={cls("filterTxt", active && "activeText filterSvg")}
            >
              筛选
              <Sx />
            </span>
          </div>
        </div>
      </div>

      <OrderDrawer
        visible={visible}
        value={value}
        conditionList={conditionList}
        onChange={change}
        onClose={() => setVisible(false)}
        searchDates={searchDates}
      />
      <style jsx>{`
        .custom-tabs :global(.rv-tabs__line) {
          width: 18px;
        }
        .custom-tabs :global(.rv-tabs__wrap) {
          border-top: 1px solid #f7f7f7;
          border-bottom: 1px solid #f7f7f7;
          box-sizing: content-box;
        }
        .custom-tabs :global(.rv-cell) {
          background-color: transparent;
          flex: 1;
        }
        .sub-filter {
          height: 46px;
          padding: 0 16px;
          background: #fff;
          font-size: 14px;
          color: #333333;
          text-align: right;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sub-filter :global(.van-icon) {
          border-color: var(--primaryColor);
        }
        .right-case {
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }

        .filter-btn {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .filter-btn :global(.filterSvg svg) {
          margin-left: 2px;
          width: 12px;
          transform: translateY(1px);
        }

        .filter-btn :global(.filterSvg svg path) {
          fill: var(--primaryColor);
        }
      `}</style>
    </>
  )
}

type SortIconProps = {
  orderBy: OrderBy
}

export function SortIcon({ orderBy }: SortIconProps) {
  return (
    <div className="sortIcon">
      <div className={cls("triangleTop", orderBy === 1 && "active")}></div>
      <div className={cls("triangleBottom", orderBy === 2 && "active")}></div>
      <style jsx>{`
        .sortIcon {
          display: inline-block;
          vertical-align: middle;
          margin-left: 2px;
          margin-right: 30px;
        }

        .triangleTop {
          width: 0;
          height: 0;
          border-bottom: 4px solid #c3c3c3;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
        }

        .triangleTop.active {
          border-bottom-color: var(--primaryColor);
        }

        .triangleBottom {
          width: 0;
          height: 0;
          border-top: 4px solid #c3c3c3;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          margin-top: 3px;
        }

        .triangleBottom.active {
          border-top-color: var(--primaryColor);
        }
      `}</style>
    </div>
  )
}
